import { Injectable, OnDestroy } from '@angular/core';
import {
    HubConnection,
    HubConnectionBuilder,
    IHttpConnectionOptions
} from '@microsoft/signalr';
import { Subscription } from 'rxjs';
import { EnvironmentService } from 'src/app/library/services/core/environment.service';
import { UserAuthService } from '../../auth/services/user.service';
import { MaintenanceService } from './maintenance.service';

@Injectable({
    providedIn: 'root'
})
export class MaintenanceSignalRService implements OnDestroy {
    private hubConnection: HubConnection;
    private _subscriptions = new Subscription();

    constructor(
        private userAuthService: UserAuthService,
        private environmentService: EnvironmentService,
        private maintenanceService: MaintenanceService
    ) {}

    public startConnection() {
        this._subscriptions = this.userAuthService.accessToken$.subscribe(
            token => {
                if (token) this.initConnection(token);
            }
        );
    }

    private async initConnection(token: string) {
        if (this.hubConnection) {
            await this.hubConnection.stop();
        }

        const options: IHttpConnectionOptions = {
            accessTokenFactory: () => {
                return token;
            }
        };

        this.hubConnection = new HubConnectionBuilder()
            .withUrl(
                `${this.environmentService.environmentConfig.maintenanceHubUrl}maintenance`,
                options
            )
            .withAutomaticReconnect()
            .build();

        this.hubConnection
            .start()
            .then(() => {
                console.log('Maintenance hub signalR connection started.');
                this.IsInMaintenance();
                this.addListeners();
            })
            .catch(err => {
                this.maintenanceService.inMaintenance = false; // fail safe if the hub doesnt connect.
                console.error(
                    'Error while starting connection to signalR maintenance hub: ' +
                        err
                );
            });
    }

    private addListeners(): void {
        this.hubConnection.on('StartMaintenance', () => {
            console.log(`Entering maintenance mode.`);
            this.maintenanceService.inMaintenance = true;
        });

        this.hubConnection.on('EndMaintenance', () => {
            console.log(`Exiting maintenance mode.`);
            this.maintenanceService.inMaintenance = false;
        });
    }

    private IsInMaintenance() {
        this.hubConnection
            .invoke('IsInMaintenance')
            .then(
                (inMaintenance: boolean) =>
                    (this.maintenanceService.inMaintenance = inMaintenance)
            );
    }

    ngOnDestroy(): void {
        this._subscriptions.unsubscribe;
        if (this.hubConnection) {
            this.hubConnection.stop();
        }
    }
}
